"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VButton_vue_1 = __importDefault(require("./scraps/VButton.vue"));
var VAuthorized_vue_1 = __importDefault(require("./scraps/VAuthorized.vue"));
var VUnauthorized_vue_1 = __importDefault(require("./scraps/VUnauthorized.vue"));
var AuthorizedLinks_vue_1 = __importDefault(require("./TheNavbar/AuthorizedLinks.vue"));
var UnauthorizedLinks_vue_1 = __importDefault(require("./TheNavbar/UnauthorizedLinks.vue"));
exports.default = vue_1.default.extend({
    name: "the-navbar",
    components: {
        VButton: VButton_vue_1.default,
        VAuthorized: VAuthorized_vue_1.default,
        VUnauthorized: VUnauthorized_vue_1.default,
        AuthorizedLinks: AuthorizedLinks_vue_1.default,
        UnauthorizedLinks: UnauthorizedLinks_vue_1.default
    }
});
